<template>
  <nav id="nlhpc-header" class="navbar navbar-expand-md fixed-top">
    <!-- Vista de escritorio -->
    <div class="container-fluid">
      <router-link class="navbar-brand nlhpc-logo2 nav-top-fixed" :to="'/'"></router-link>
      <div class="align-items-center d-block d-none d-md-block">
        <HeaderButtons
          :fromFather="modeTheme"
          :token="token"
          style="text-align: right; display: inline-block"
          class="my-2"
        />
        <HeaderLogin class="float-end" />
      </div>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
        style="border: 1px solid var(--negro); padding: 10px"
      >
        <i class="navbar-toggler-icon2 fa-solid fa-chevron-down"></i>
      </button>
    </div>

    <!-- Vista movil -->
    <div class="container-fluid d-sm-block d-md-none">
      <div class="row" style="width: 100%">
        <div class="col-12 collapse text-start" id="navbarNav">
          <ul class="navbar-nav my-3">
            <li class="break">
              <hr />
            </li>

            <li class="nav-item">
              <router-link to="/noticias" class="nav-link" style="color: var(--negro)">
                <i class="fas fa-bullhorn"></i> Noticias
              </router-link>
            </li>

            <li class="nav-item">
              <router-link
                v-if="this.$nlhpc.getUser().admin"
                to="/administracion"
                class="nav-link"
                style="color: var(--negro)"
              >
                <i class="fa-solid fa-gear"></i> Administración
              </router-link>
            </li>

            <li class="break">
              <hr />
            </li>

            <li class="nav-item">
              <a class="nav-link" href="#" v-on:click="changeMode()">
                <span v-if="modeTheme" style="color: var(--negro)">
                  <i class="fas fa-moon"></i> Modo oscuro
                </span>
                <span v-else style="color: var(--negro)">
                  <i class="fas fa-sun"></i> Modo claro
                </span>
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                target="_blank"
                href="https://wiki.nlhpc.cl"
                style="color: var(--negro)"
              >
                <i class="fab fa-wikipedia-w"></i> Wiki NLHPC
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                href="https://wiki.nlhpc.cl/Generador_Scripts"
                style="color: var(--negro)"
              >
                <i class="fas fa-robot"></i> Generador de Script
              </a>
            </li>

            <li class="nav-item" v-if="token">
              <a class="nav-link" href="#" @click="openSSH()" style="color: var(--negro)">
                <i class="fas fa-terminal"></i> Consola
              </a>
            </li>

            <li class="nav-item" v-if="token">
              <router-link class="nav-link" :to="'/noticias'" style="color: var(--negro)">
                <i class="fas fa-bell"></i>
                Noticias
              </router-link>
            </li>

            <li class="break">
              <hr />
            </li>

            <li class="nav-item" v-if="token">
              <router-link class="nav-link" :to="'/profile'" style="color: var(--negro)">
                <i class="fas fa-user"></i> Perfil de usuario
              </router-link>
            </li>

            <li class="nav-item" v-else>
              <router-link class="nav-link" :to="'/login'" style="color: var(--negro)">
                <i class="fas fa-user"></i> Iniciar sesión
              </router-link>
            </li>

            <li class="nav-item" v-if="token">
              <a
                class="nav-link"
                href="#"
                v-on:click="closeSession()"
                style="color: var(--negro)"
              >
                <i class="fas fa-sign-out-alt"></i> Cerrar sesión
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<!-- eslint-disable no-undef -->
<script>
import HeaderLogin from "@/components/HeaderLogin.vue";
import HeaderButtons from "@/components/HeaderButtons.vue";

export default {
  name: "MainHeader",

  components: {
    HeaderLogin,
    HeaderButtons,
  },

  data() {
    return {
      modeTheme: true,
    };
  },

  props: {
    token: {
      type: String,
      default: null,
    },
  },

  methods: {
    closeSession() {
      window.localStorage.removeItem("token");
      location.href = "/";
    },

    changeMode() {
      this.modeTheme = this.modeTheme ? false : true;
    },

    openSSH() {
      let url = `https://ssh.dashboard.nlhpc.cl/?username=${this.token}`;
      let target = "_blank";
      let width = screen.width / 2;
      let height = screen.height / 2;
      let location = `left=${screen.width / 2},top=${screen.height / 2}`;
      let size = `width=${width},height=${height}`;
      if (screen.width <= 1024) size = "fullscreen=1";
      let options = `${location},${size},resizable=1,status=0,toolbar=0,menubar=0,scrollbars=1,titlebar=0`;

      window.open(url, target, options);
    },

    openScript() {
      $("#modalScript").modal("show");
    },
  },

  created() {
    let theme = localStorage.getItem("_theme");
    this.modeTheme = theme == "light" ? true : false;
  },
};
</script>

<style scoped>
.navbar-toggler-icon2 {
  color: var(--negro);
}
</style>
